<template>
    <div>
        <!-- Escalate invoice/contract modals -->
        <InvoiceEscalateModals
            ref="InvoiceEscalateModals"
            :showEscalation="showEscalation"
            :showOutEscalation="showOutEscalation"
        />

        <!-- Resend invoice modal -->
        <b-modal :active.sync="resendModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Opnieuw versturen</p></header>
                <section class="modal-card-body text-left" style="overflow: hidden;border-radius:0;">
                    Weet je zeker dat je de {{ type == 'credit' ? 'creditfactuur' : 'factuur' }} opnieuw wilt versturen?
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" :disabled="loading" @click="resendModalOpen = false">Annuleren</b-button>
                    <b-button type="is-success" @click="resend" :loading="loading">Versturen</b-button>
                </footer>
            </div>
        </b-modal>

        <!-- Cancel invoice modal -->
        <b-modal :active.sync="cancelModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Annuleren</p></header>
                <section class="modal-card-body text-left" style="overflow: hidden;border-radius:0;">
                    <template v-if="!cancelEligible && cancelReason === 'incasso_planned'">
                        Op dit moment is annuleren niet mogelijk omdat er een incasso-opdracht is aangemeld. Wacht op de terugkoppeling voordat je kunt annuleren.
                    </template>
                    <template v-else-if="!cancelEligible && cancelReason === 'paid'">
                        Annuleren is niet mogelijk omdat de factuur al is betaald.
                    </template>
                    <template v-else-if="!cancelEligible && cancelReason === 'cancelled'">
                        Annuleren is niet mogelijk omdat de factuur al is geannuleerd.
                    </template>
                    <template v-else-if="!cancelEligible && cancelReason === 'escalated'">
                        Annuleren is niet mogelijk omdat de factuur is geëscaleerd.
                    </template>
                    <template v-else>
                        Weet je zeker dat je de {{ type == 'credit' ? 'creditfactuur' : 'factuur' }} wilt annuleren?
                    </template>
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" :disabled="loading" @click="cancelModalOpen = false">Sluiten</b-button>
                    <b-button type="is-danger" @click="cancel" :loading="loading" v-if="loading || !loading && cancelEligible">Annuleren</b-button>
                </footer>
            </div>
        </b-modal>

        <!-- Restore invoice modal -->
        <b-modal :active.sync="restoreModalOpen" class="invitemodal" :width="640" scroll="keep">
            <div class="modal-card">
                <header class="modal-card-head"><p class="modal-card-title">Herstellen</p></header>
                <section class="modal-card-body text-left" style="overflow: hidden;border-radius:0;">
                    Weet je zeker dat je deze {{ type == 'credit' ? 'creditfactuur' : 'factuur' }} wilt herstellen?
                </section>
                <footer class="modal-card-foot">
                    <b-button type="is-light" :disabled="loading" @click="restoreModalOpen = false">Sluiten</b-button>
                    <b-button type="is-success" @click="restore" :loading="loading">Herstellen</b-button>
                </footer>
            </div>
        </b-modal>

        <div class="invoice-options-dropdown">
            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: type === 'geescaleerd' ? 'EscalationRecord' : 'InvoicesRecord', params: {type: type, id: record.id} }">Bekijken</b-button>
            <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left" v-if="showDropdown">
                <template #trigger>
                    <b-button
                        type="is-dark"
                        size="is-small"
                        icon-right="chevron-down" />
                </template>

                <b-dropdown-item aria-role="listitem" :disabled="!resendPossible" @click="resendModalOpen = true">Opnieuw versturen</b-dropdown-item>
                <router-link v-if="!hideCreditButton && !user.deurwaarder" class="dropdown-item" aria-role="listitem" has-link :to="{ name: 'InvoicesRecord', params: {type: type, id: record.id}, query: {'creditinvoice': true} }">Maak creditfactuur</router-link>
                <b-dropdown-item aria-role="listitem" v-if="showEscalation && !user.deurwaarder" :disabled="cantEscalate" @click="$refs['InvoiceEscalateModals'].toggleEscalateModal({esc_invoice: record.id, esc_contract: _.has(record, 'contract.id') ? record.contract.id : record.contract ? record.contract : null, customer: record.customer.id })">{{ escalationName == 'escalatie' ? 'Escaleren' : 'Deurwaarder' }}</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" v-if="record.status !== 'cancelled'" @click="preOpenCancelModal" class="has-text-danger">Annuleren</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" v-else @click="restoreModalOpen = true">Herstellen</b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import toastMixin from '@/mixins/toastMixins.js'
import escalationMixin from '@/mixins/escalationMixin.js'
import InvoiceEscalateModals from '@/vue/invoices/components/InvoiceEscalateModals'

export default {
    name: 'InvoiceOptionsDropdown',

    mixins: [toastMixin, escalationMixin],

    components: {
        InvoiceEscalateModals
    },

    props: {
        type: {
            type: String,
            default: 'recent',
            required: false
        },

        record: {
            type: Object,
            required: true
        },

        showDropdown: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        resendPossible() {
            return !_.isNull(this.record.send_at)
        },

        user() {
            return this.$store.state.user
        },

        hideCreditButton() {
            let hideButton = false

            if(_.has(this.user.organisation_settings, 'strictcredits') && this.user.organisation_settings.strictcredits == 1 && (this.user.role != 'admin' && !this.user.is_admin) || (this.type == 'credit')){
                hideButton = true
            }

            return hideButton
        }
    },

    data() {
        return {
            loading: false,
            resendModalOpen: false,
            cancelModalOpen: false,
            restoreModalOpen: false,
            cancelEligible: true,
            cancelReason: null
        }
    },

    methods: {
        preOpenCancelModal() {
            this.loading = true
            this.cancelEligible = true
            this.cancelReason = null
            this.cancelModalOpen = true

            axios.get('/api/invoices/'+this.record.id+'/cancel-eligibility', {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.cancelEligible = response.data.canCancel
                this.cancelReason = response.data.reason || null
            }).catch((e) => {
                console.error(e)
                this.cancelEligible = false
                this.cancelReason = 'unknown'
            }).then(() => {
                this.loading = false
            })
        },

        resend() {
            this.loading = true

            axios.post('/api/invoices/'+this.record.id+'/resend', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage(`Opnieuw versturen van ${this.type == 'credit' ? 'creditfactuur' : 'factuur'} ingepland!`)
                this.$emit('reloadInvoices')
            }).catch((e) => {
                if (e?.response?.data?.error == 'invoice-on-hold') {
                    return this.showError('Er kan geen factuur opnieuw worden verzonden omdat het contract nog niet is ondertekend door de klant.')
                }

                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
            }).then(() => {
                this.loading = false
                this.resendModalOpen = false
            })
        },

        cancel() {
            this.loading = true

            axios.post('/api/invoices/'+this.record.id+'/cancel', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage(`${this.type == 'credit' ? 'Creditfactuur' : 'Factuur'} is geannuleerd!`)
                this.$emit('reloadInvoices')
            }).catch((e) => {
                console.error(e)
                if (e?.response?.data === 'incasso_planned') {
                    this.showError('Annuleren is niet mogelijk: er staat een incasso-opdracht aangemeld.')
                } else {
                    this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                }
            }).then(() => {
                this.loading = false
                this.cancelModalOpen = false
            })

        },

        restore() {
            this.loading = true

            axios.post('/api/invoices/'+this.record.id+'/restore', {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.showMessage(`${this.type == 'credit' ? 'Creditfactuur' : 'Factuur'} is hersteld!`)
                this.$emit('reloadInvoices')
            }).catch((e) => {
                console.error(e)
                if (e?.response?.data?.error === 'invoice-not-cancelled') {
                    this.showError('Herstellen is niet mogelijk: de factuur is niet geannuleerd.')
                } else if (e?.response?.data?.error === 'invoice-already-paid') {
                    this.showError('Herstellen is niet mogelijk: de factuur is al betaald.')
                } else if (e?.response?.data?.error === 'invoice-escalated') {
                    this.showError('Herstellen is niet mogelijk: de factuur is geëscaleerd.')
                } else {
                    this.showError('Daar gaat iets fout! Probeer het opnieuw.')
                }
            }).then(() => {
                this.loading = false
                this.restoreModalOpen = false
            })
        }
    }
}
</script>

<style scoped>
.invoice-options-dropdown {
    display: flex;
    white-space: nowrap;
    justify-content: flex-end;
}

/* Ensure dropdown menu doesn't get cut off */
.dropdown-menu {
    min-width: 160px;
    z-index: 100;
}

/* Prevent dropdown items from wrapping */
.dropdown-item {
    white-space: nowrap;
}
</style>
